import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { tgAdvisoryApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
export interface IFile {
  _id: string;
  id: string;

  type: string;
  fileLink: string;
  name: string;
  status: string;
  endedAt: string;
  startedAt: string;
  createdAt: string;
}
@Component({
  selector: 'app-tgadvisort-report',
  templateUrl: './tgadvisort-report.component.html',
  styleUrls: ['./tgadvisort-report.component.scss']
})
export class TgadvisortReportComponent implements OnInit {

  isAddEditCalled: boolean = false;
  userDataToEdit: any;
  p: any = 1;
  count: any = 50;

  opened: boolean = false;
  modeNum: number = 0;
  positionNum: number = 0;
  dock: boolean = false;
  closeOnClickOutside: boolean = false;
  closeOnClickBackdrop: boolean = true;
  showBackdrop: boolean = false;
  animate: boolean = true;
  trapFocus: boolean = true;
  autoFocus: boolean = true;
  keyClose: boolean = false;
  toggleSortDiv: boolean = false;
  downloadReport: boolean = false;

  listOfReportsToDisplay: Array<IFile> = [];
  listOfReports: Array<IFile> = [];
  userDetails: any;
  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);

    this.fetchAllReport();
  }

  constructor(
    private matDialog: MatDialog,
    public appService: AppService,
    public routes: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) { }

  userDetail: any;
  isLoading: boolean = true;
  myHeaders = new Headers();

  async fetchAllReport() {
    this.listOfReports = [];
    let URL = '';
    let param = {};

    URL = `${tgAdvisoryApi.domain + tgAdvisoryApi.endPoint.fetchAllReport}`;
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    await this.appService
      .postMethodWithToken(param, URL, httpHeaders)
      .then((data: any) => {
        if (data['success']) {
          data['result'].forEach((report: any) => {
            this.listOfReports.push({
              _id: report['_id'],
              id: report['_id'],
              type: report['type'],
              createdAt: report['createdAt'],
              startedAt: report['startedAt'],
              endedAt: report['endedAt'],
              status: report['status'],
              fileLink: report['fileLink'],
              name: report['fileName'],
            });
          });
          this.listOfReportsToDisplay = this.listOfReports;
          this.isLoading = false;
        }
      });
  }
  getTimeDifference(end: string, start: string) {
    var startDate = new Date(end);
    var endDate = new Date(start);
    var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    return seconds;
  }
  downloadReportXl(purchaseOrder: any) {
    window.open(purchaseOrder['fileLink'], '_blank');
  }
  searchData(target: any) {
    console.log(target.value);
    let serachQuery = target.value;
    if (serachQuery != '') {
      let tempSearchList: any = [];
      this.listOfReportsToDisplay = [];

      this.listOfReports.forEach((report: any, index: number) => {
        if (
          String(report['type'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(report['createdAt'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(report['fileLink'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(report['name'])
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase())
        ) {
          tempSearchList.push(report);
        }
      });
      this.listOfReportsToDisplay = [];
      this.listOfReportsToDisplay = tempSearchList;
    } else {
      this.listOfReportsToDisplay = this.listOfReports;
    }
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showWarninigToaster(message: string | undefined, title: string | undefined) {
    this.toastr.warning(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

}
